import React from 'react';
import { 
    SplitFormRow, 
    DocketNumField, 
    DocketTitleField, 
    ServiceDateRangeField, 
    DecisionTypeField, 
    DecisionIdField, 
    DecidingBodyField, 
    SummaryField, 
    DocumentSearchField, 
    FilingDateRangeField, 
    FilingTypeField, 
    FiledForField, 
    FilingIdField, 
    DateToViewField,
    RecordationNumberField,
    RecordationSuffixField,
    RecordationTypeOfAgreementField,
    RecordationEquipmentDescriptionField,
    RecordationPartyField,
    DynamicFormRow,
	RecordationFilingDateRangeField,
	EnvCommentIdField,
	OrganizationField,
	EnvCommentsDateRangeField,
	SubmitterRecipientField
} from './common';
import { 
	DECISIONS_SEARCH_FOR_OPTION, 
	FILINGS_SEARCH_FOR_OPTION, 
	DOCKETS_SEARCH_FOR_OPTION, 
	BY_DATE_SEARCH_FOR_OPTION, 
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
} from '../../../resources/constants/searches';
import { CategoryRadioButton, EnvCommTypeRadioButton } from '../../Form/components/common';

class DecisionsSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<SplitFormRow>
					<DocketNumField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<DocketTitleField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>

				<ServiceDateRangeField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>

				<SplitFormRow>
					<DecisionTypeField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<DecisionIdField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>
				<SplitFormRow>
					<DecidingBodyField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<SummaryField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>

				<DocumentSearchField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
			</React.Fragment>
		);
	}
}

class FilingsSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<SplitFormRow>
					<DocketNumField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<DocketTitleField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>

				<FilingDateRangeField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>

				<FilingTypeField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
				/>

				<SplitFormRow>
					<FiledForField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<FilingIdField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>
				<DocumentSearchField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
			</React.Fragment>
		);
	}
}

class DocketsSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<SplitFormRow>
					<DocketNumField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<DocketTitleField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>
			</React.Fragment>
		);
	}
}

class RecordationsSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<DynamicFormRow>
					<CategoryRadioButton 
						size={6}
						inline 
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<RecordationNumberField
						size={4}
						labelSize={6}
						fields={this.props.fields}
                        handleChange={this.props.handleChange}
					/>
					<RecordationSuffixField
                        size={2}
						fields={this.props.fields}
                        handleChange={this.props.handleChange}
					/>
				</DynamicFormRow>
				<RecordationFilingDateRangeField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
                <RecordationPartyField
                    fields={this.props.fields}
                    handleChange={this.props.handleChange}
                />
                <RecordationTypeOfAgreementField
                    fields={this.props.fields}
                    handleChange={this.props.handleChange}
                />
                <RecordationEquipmentDescriptionField
                    fields={this.props.fields}
                    handleChange={this.props.handleChange}
                />
                <DocumentSearchField
                    fields={this.props.fields}
                    handleChange={this.props.handleChange}
                    clearFieldsByName={this.props.clearFieldsByName}
                />
			</React.Fragment>
		);
	}
}

class EnvironmentalCommentsSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<DynamicFormRow>
					<EnvCommTypeRadioButton
						size={6}
						inline
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<EnvCommentIdField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</DynamicFormRow>
				<SplitFormRow>
					<DocketNumField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
					<DocketTitleField
						fields={this.props.fields}
						handleChange={this.props.handleChange}
					/>
				</SplitFormRow>

				<EnvCommentsDateRangeField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>

				<OrganizationField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
				/>
				<SubmitterRecipientField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
				/>

				<DocumentSearchField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
			</React.Fragment>
		);
	}
}

class ByDateSearch extends React.Component {
	render() {
		return (
			<React.Fragment>
				<DateToViewField
					fields={this.props.fields}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
			</React.Fragment>
		);
	}
}

export class DataTypeSearch extends React.Component {
	render() {
		return (() => {
			switch (this.props.searchFor) {
				case DECISIONS_SEARCH_FOR_OPTION:
					return (
						<DecisionsSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
							clearFieldsByName={this.props.clearFieldsByName}
						/>
					);
				case FILINGS_SEARCH_FOR_OPTION:
					return (
						<FilingsSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
							clearFieldsByName={this.props.clearFieldsByName}
						/>
					);
				case DOCKETS_SEARCH_FOR_OPTION:
					return (
						<DocketsSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
						/>
					);
				case RECORDATIONS_SEARCH_FOR_OPTION:
					return (
						<RecordationsSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
							lockedTo={this.props.lockedTo}
							clearFieldsByName={this.props.clearFieldsByName}
						/>
					);
				case ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION:
					return (
						<EnvironmentalCommentsSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
							clearFieldsByName={this.props.clearFieldsByName}
						/>
					);
				case BY_DATE_SEARCH_FOR_OPTION:
					return (
						<ByDateSearch
							fields={this.props.fields}
							handleChange={this.props.handleChange}
							clearFieldsByName={this.props.clearFieldsByName}
						/>
					);
				default:
					return null;
			}
		})();
	}
}